<script>
  export default{

  }
</script>

<style lang="sass">

    @import ../../common/styles/settings

    .view-offers

        &--homepage
            background: #F7F7F7

            & + &
                margin-top: 1.375rem

        &--grid

            padding-left: $baseline
            padding-right: $baseline

            +media('>xsmall')
                padding-left: $baseline*1.5
                padding-right: $baseline*1.5

            +media('>small')
                padding: 0

            &__col
                min-height: 100%
                background-color: #f7f7f7
                border-radius: .25rem
                padding: $baseline 0
                box-sizing: border-box

                +media('>xsmall')
                    padding: $baseline

                +media('>small')
                    padding: $baseline*1.5

                +media('>medium')
                    padding: $baseline*2


            .view-offers__title
                text-align: center
                svg
                    display: block
                    margin: 0 auto
                    height: 5.5rem
                    width: 5.5rem

            .button
                width: 100%
                text-align: center
                margin-top: 1.375rem

            .offer
                box-shadow: $card-shadow-higher

                + .offer
                    margin-top: 1.375rem
</style>
